var map = {
	"./b1.mp3": 1365,
	"./b10.mp3": 4623,
	"./b11.mp3": 6122,
	"./b12.mp3": 4125,
	"./b13.mp3": 8376,
	"./b14.mp3": 5691,
	"./b15.mp3": 4918,
	"./b2.mp3": 5234,
	"./b3.mp3": 167,
	"./b4.mp3": 6684,
	"./b5.mp3": 2017,
	"./b6.mp3": 9582,
	"./b7.mp3": 9875,
	"./b8.mp3": 8040,
	"./b9.mp3": 8029,
	"./bingo.mp3": 6251,
	"./g46.mp3": 1179,
	"./g47.mp3": 406,
	"./g48.mp3": 4149,
	"./g49.mp3": 3408,
	"./g50.mp3": 4598,
	"./g51.mp3": 9787,
	"./g52.mp3": 9060,
	"./g53.mp3": 4009,
	"./g54.mp3": 2282,
	"./g55.mp3": 1247,
	"./g56.mp3": 5992,
	"./g57.mp3": 4301,
	"./g58.mp3": 3294,
	"./g59.mp3": 1539,
	"./g60.mp3": 903,
	"./i16.mp3": 7526,
	"./i17.mp3": 9931,
	"./i18.mp3": 2624,
	"./i19.mp3": 9253,
	"./i20.mp3": 4677,
	"./i21.mp3": 4400,
	"./i22.mp3": 4823,
	"./i23.mp3": 7778,
	"./i24.mp3": 9505,
	"./i25.mp3": 2108,
	"./i26.mp3": 3443,
	"./i27.mp3": 1038,
	"./i28.mp3": 9949,
	"./i29.mp3": 2520,
	"./i30.mp3": 8574,
	"./n31.mp3": 5028,
	"./n32.mp3": 347,
	"./n33.mp3": 5926,
	"./n34.mp3": 5133,
	"./n35.mp3": 9384,
	"./n36.mp3": 9279,
	"./n37.mp3": 7130,
	"./n38.mp3": 4497,
	"./n39.mp3": 6636,
	"./n40.mp3": 7080,
	"./n41.mp3": 7037,
	"./n42.mp3": 7162,
	"./n43.mp3": 751,
	"./n44.mp3": 4852,
	"./n45.mp3": 8841,
	"./o61.mp3": 8842,
	"./o62.mp3": 861,
	"./o63.mp3": 2552,
	"./o64.mp3": 6347,
	"./o65.mp3": 1158,
	"./o66.mp3": 569,
	"./o67.mp3": 5620,
	"./o68.mp3": 8855,
	"./o69.mp3": 1810,
	"./o70.mp3": 5336,
	"./o71.mp3": 5325,
	"./o72.mp3": 3594,
	"./o73.mp3": 9231,
	"./o74.mp3": 2372,
	"./o75.mp3": 7593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6644;